import { IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class ApproveAccessRequestCommand {
  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  login: string;
}
